import React from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import InfoModal from '../../../features/components/Modals/InfoModal'
import FileDetailsPreview from '../../../components/FileDetailsPreview'

import { ReactComponent as WarningIcon } from '../../../assets/icons/warning-icon.svg'

import { uploadedFileSelector } from '../../../modules/selectors/files'

import useStyles from './styles'

const ExceptedAdsModal = ({ exceptions, onModalClose }) => {
  const classes = useStyles()
  const uploadedFilesData = useSelector(uploadedFileSelector)

  return (
    <InfoModal
      Icon={WarningIcon}
      isOpen={true}
      onClose={onModalClose} // clear exceptions
      modalTitle="There was an error creating ads using some of the files you provided"
    >
      <p>
        The ads listed below were not uploaded, please check your files and try again.
        <br /> Any ads not listed below were created successfully.
      </p>
      {exceptions.map(exception => {
        const fileName = exception.identifier
        const uploadedFile = uploadedFilesData[fileName]
        return (
          <FileDetailsPreview
            className={classes.exceptedFile}
            key={fileName}
            fileName={fileName}
            filePreviewType={'image'}
            fileUrl={uploadedFile?.url}
          />
        )
      })}
    </InfoModal>
  )
}

ExceptedAdsModal.propTypes = {
  exceptions: PropTypes.array.isRequired,
  onModalClose: PropTypes.func.isRequired
}
export default ExceptedAdsModal
